import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    suppliers: [],
    loading: false,
    error: null,
};

const supplierSlice = createSlice({
    name: 'supplier',
    initialState,
    reducers: {
        setSuppliers: (state, action) => {
            state.suppliers = action.payload;
        },
        addSupplier: (state, action) => {
            state.suppliers.push(action.payload);
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setSuppliers, addSupplier, setLoading, setError } = supplierSlice.actions;
export default supplierSlice.reducer;
